export const GET_ANSWER_STATUS_START = 'GET_ANSWER_STATUS_START';
export const GET_ANSWER_STATUS_SUCCESS = 'GET_ANSWER_STATUS_SUCCESS';
export const GET_ANSWER_STATUS_FAIL = 'GET_ANSWER_STATUS_FAIL';
export const GET_ANSWER_STATUS_RESET = 'GET_ANSWER_STATUS_RESET';
